
<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Add Bank Transfer Beneficiary </h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="submitBankTransferBeneficiaryForm(banktransferBeneficiaryForm.value)" [formGroup]="banktransferBeneficiaryForm">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Beneficiary Type</mat-label>
                          <mat-select formControlName="beneficiary_type" required>
                            <mat-option [value]="d?.code" *ngFor="let d of BeneficiaryTypelist; let i=index">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_type?.errors?.required">
                            Select Beneficiary Type is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Country</mat-label>
                          <mat-select formControlName="beneficiary_country_Accountcode" required>
                            <mat-form-field>
                              <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                            </mat-form-field>
                            <mat-option [value]="d?.code" *ngFor="let d of filterCountry(); let i=index" (click)="getBanklist(d?.code,d?.countryISDCode,d?.requestedService,d?.uniquecountrycode)">
                              <img matSuffix [src]="d?.icon" style="height: 20px;width: 20px;" />
                              {{d?.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_country_Accountcode?.errors?.required">
                            Select Country is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Bank Name</mat-label>
                          <mat-select formControlName="channel_Code" required>
                            <mat-form-field>
                              <input matInput [formControl]="BankListFilterCtrl" placeholder="Search Bank" />
                            </mat-form-field>
                            <mat-option [value]="d?.entryId" *ngFor="let d of filterBankList(); let i=index" (click)="getbankName(d?.bankName,d?.entryId)">
                              <!--<img matSuffix [src]="d?.icon"  style="height: 30px;width: 30px;" />-->
                              {{d?.bankName}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.channel_Code?.errors?.required">
                            Bank Name is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-12" *ngIf="countryISDCode == '44'">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="text" matInput placeholder="IBAN Number" formControlName="beneficiary_account_no" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_account_no?.errors?.required">
                            IBAN Number is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_account_no?.errors?.maxlength">
                            Maximum Length IBAN Number is 50
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode != '44'">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="text" matInput placeholder="Bank Account Number" formControlName="beneficiary_account_no" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_account_no?.errors?.required">
                            Bank Account Number is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_account_no?.errors?.maxlength">
                            Maximum Length Bank Account Number is 50
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="uniquecountrycode == 'EUR'">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="text" matInput placeholder="IBAN Number" formControlName="beneficiary_account_no" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_account_no?.errors?.required">
                            IBAN Number is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_account_no?.errors?.maxlength">
                            Maximum Length IBAN Number is 50
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '91'">
                        <mat-form-field>
                          <input matInput placeholder="Enter IFS Code" formControlName="beneficiary_bank_code" minlength="5" maxlength="20" required />
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.maxlength">
                            Maximum Length IFS Code is 20
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.minlength">
                            Minimum Length IFS Code is 5
                          </mat-error>
                          <mat-error *ngIf="submitted && f.beneficiary_bank_code?.errors?.required">
                            Enter IFS Code is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '81' ||  countryISDCode == '92' ||  countryISDCode == '61' ||  countryISDCode == '55' ">
                        <mat-form-field>
                          <input matInput placeholder="Enter Bank Branch Code" formControlName="beneficiary_bank_code" minlength="1" maxlength="20" required />
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.maxlength">
                            Maximum Length Bank Branch Code is 20
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.minlength">
                            Minimum Length Bank Branch Code is 1
                          </mat-error>
                          <mat-error *ngIf="submitted && f.beneficiary_bank_code?.errors?.required">
                            Enter Bank Branch Code is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '880'">
                        <mat-form-field class="example-full-width">
                          <mat-label>Select Bank Branch Code</mat-label>

                          <mat-select formControlName="beneficiary_bank_code" required>
                            <mat-option [value]="d?.entryId" *ngFor="let d of branchcodebangladeshLNlist; let i=index">
                              {{d?.bankBranchName}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_bank_code?.errors?.required">
                            Select Bank Branch Code
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12" *ngIf="countryISDCode == '1'">
                        <mat-form-field>
                          <input matInput placeholder="Enter Routing Number" formControlName="beneficiary_bank_code" minlength="1" maxlength="50" required />
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.maxlength">
                            Maximum Length Routing Number is 50
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.minlength">
                            Minimum Length Routing Number is 1
                          </mat-error>
                          <mat-error *ngIf="submitted && f.beneficiary_bank_code?.errors?.required">
                            Enter Routing Number is required
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary First Name" formControlName="beneficiary_fname" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_fname?.errors?.required">
                            Enter Beneficiary First Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_fname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Middle Name(optional)" formControlName="beneficiary_mname" maxlength="50" />

                          <mat-error *ngIf="submitted && f.beneficiary_mname?.errors?.required">
                            Enter Beneficiary Middle Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_mname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Last Name" formControlName="beneficiary_lname" maxlength="50" required />

                          <mat-error *ngIf="submitted && f.beneficiary_lname?.errors?.required">
                            Enter Beneficiary Last Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_lname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Address" formControlName="beneficiary_address" maxlength="150" required />

                          <mat-error *ngIf="submitted && f.beneficiary_address?.errors?.required">
                            Enter Beneficiary Address
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_address?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>

                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary State" formControlName="beneficiary_state" maxlength="50" />

                          <mat-error *ngIf="submitted && f.beneficiary_state?.errors?.required">
                            Enter Beneficiary State
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '61'">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary City" formControlName="beneficiary_city" maxlength="200" />

                          <mat-error *ngIf="submitted && f.beneficiary_city?.errors?.required">
                            Enter Beneficiary City
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '61'">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary ZipCode" formControlName="beneficiary_zipcode" maxlength="15" />

                          <mat-error *ngIf="submitted && f.beneficiary_zipcode?.errors?.required">
                            Enter Beneficiary ZipCode
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="!chnbankCode">
                        <mat-form-field class="example-full-width input-tel">
                          <span matPrefix>{{countryISDCode}} &nbsp;</span>
                          <input type="tel" matInput placeholder="Beneficiary Mobile Number (eg:244476305)"
                                 formControlName="beneficiary_phone" Numberonly minlength="{{minchn}}" maxlength="{{maxchn}}" required />
                          <mat-error *ngIf="submitted && f.beneficiary_phone?.errors?.required">
                            Beneficiary Mobile No. is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.maxlength">
                            Maximum Length Beneficiary Mobile No. is {{maxchn}}
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.minlength">
                            Minimum Length Beneficiary Mobile No. is {{minchn}}
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12">
                        <mat-form-field>
                          <input matInput type="email" placeholder="Beneficiary Email" formControlName="beneficiary_email" maxlength="100" required />
                          <mat-error *ngIf="submitted && f.beneficiary_email.errors">
                            Enter Valid Email
                          </mat-error>
                        </mat-form-field>

                      </div>

                      <div class="col-12" *ngIf="countryISDCode == '55' ">
                        <mat-form-field>
                          <input matInput placeholder="Enter CPF Number" formControlName="SourceofFund" minlength="1" required />
                          
                          
                          <mat-error *ngIf="submitted && f.SourceofFund?.errors?.required">
                            Enter CPF Number is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Beneficiary Relationship with Sender</mat-label>
                          <mat-select formControlName="beneficiary_relationship" required>
                            <mat-option [value]="d?.code" *ngFor="let d of BeneficiaryRelationshiplist; let i=index" (click)="CheckBeneficiaryRelationship(d?.code)">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_relationship?.errors?.required">
                            Select Beneficiary Relationship with Sender is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="OtherRemarkslist">
                        <mat-form-field>
                          <mat-label>Select Other Remarks</mat-label>
                          <mat-select formControlName="beneficiary_Other_Remarks" required>
                            <mat-option [value]="d?.code" *ngFor="let d of OtherRemarkslist; let i=index">

                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_Other_Remarks?.errors?.required">
                            Select Other Remarks is required
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12" *ngIf="servicename =='LI'">
                        <mat-form-field class="example-full-width">
                          <mat-label> Sender Occupation</mat-label>
                          <mat-select formControlName="senderOccupation" required>
                            <mat-option [value]="d?.data" *ngFor="let d of senderOccupationlist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.senderOccupation?.errors?.required">
                            Select Sender Occupation
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12" *ngIf="servicename =='LI'">
                        <mat-form-field class="example-full-width">
                          <mat-label> Sender Fund Source</mat-label>
                          <mat-select formControlName="senderSourceOfFund" required>
                            <mat-option [value]="d?.data" *ngFor="let d of senderSourceOfFundlist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.senderSourceOfFund?.errors?.required">
                            Select Sender Fund Source
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <mat-label> Remittance Purpose</mat-label>
                          <mat-select formControlName="purposeofremittance" required>
                            <mat-option [value]="d?.data" *ngFor="let d of purposeofremittancelist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.purposeofremittance?.errors?.required">
                            Select Remittance Purpose
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12" *ngIf="servicename =='MFS' || servicename =='FI'">
                        <mat-form-field class="example-full-width">
                          <mat-label> Beneficiary Id Type</mat-label>
                          <mat-select formControlName="beneficiary_idMFS" required>
                            <mat-option [value]="d?.code" *ngFor="let d of Idprooflist; let i=index">
                              {{d?.doc_Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_idMFS?.errors?.required">
                            Select Beneficiary Id Type
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-12" *ngIf="servicename =='LI'">
                        <mat-form-field class="example-full-width">
                          <mat-label> Beneficiary Id Type</mat-label>

                          <mat-select formControlName="beneficiary_idLI" required>
                            <mat-option [value]="d?.data" *ngFor="let d of Idprooflist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.beneficiary_idLI?.errors?.required">
                            Select Beneficiary Id Type
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="Beneficiary Id Number" maxlength="100" formControlName="beneficiary_id_number" required>
                          <mat-error *ngIf="submitted && f.beneficiary_id_number?.errors?.required">
                            Enter Beneficiary Id Number
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="Receiver Id Expiry Date" [matDatepicker]="picker2" [min]="maxDate" maxlength="10"
                                 formControlName="ReceiverIdExpiryDate" required>
                          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                          <mat-datepicker #picker2></mat-datepicker>
                          <mat-error *ngIf="submitted && f.ReceiverIdExpiryDate?.errors?.required">
                            Select Receiver Id Expiry Date
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="Receiver Date of Birth" [matDatepicker]="picker1" [max]="maxDate" maxlength="10"
                                 formControlName="ReceiverDateofbirth" required>
                          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                          <mat-error *ngIf="submitted && f.ReceiverDateofbirth?.errors?.required">
                            Select Receiver Date of Birth
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>


                  <div class="col-12">
                    <button class="primary-btn" type="submit"> SUBMIT</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
    <div class="two-card recent-card common-padding pay-money shadow overflow-auto">
      <h2 class="heading recent-head">Beneficiary Add</h2>
      <table class="table table-hover text-center  table-bordered">
        <thead>
          <tr>
            <th>Country</th>
            <th>Category Name</th>
            <th>Channel</th>
            <th>Mobile No.</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of userorderdetailList; let i=index">
          <tr>
            <td>
              {{x.beneficiary_country}}
            </td>

            <td>{{x.beneficiary_serviceName}}</td>
            <td>{{x.channel}}</td>
            <td>{{x.beneficiary_phone}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

</fieldset>
